<template>
  <div>
    <span> Numero PLP: {{ plpExternalData.plp }} </span>
    <el-table :data="plpExternalData.tags" stripe ref="tablePrepost">
      <el-table-column align="center" prop="tag" label="Objeto" />
      <el-table-column align="center" prop="serviceCode" label="Cod Serviço" />
      <el-table-column
        align="center"
        label="CEP Destino"
        prop="information.zipcode"
      >
        <template slot-scope="scope">
          {{
            scope.row.zipcode
              ? scope.row.zipcode
              : scope.row.information.zipcode | zipcodeFormater
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="postedAt"
        :label="'Data da prepostagem'"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.postedAt | dateFormater }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "OrderExternalObjects",
  props: {
    plpExternalData: Array,
    os_id: Number,
  },

  filters: {
    dateFormater(date) {
      if (date) {
        return moment.utc(date).utcOffset("+03:00").format("DD/MM/YYYY");
      }
    },

    zipcodeFormater(zipcode) {
      if (zipcode)
        return (
          zipcode.substring(0, 2) +
          "." +
          zipcode.substring(2, 5) +
          "-" +
          zipcode.substring(5)
        );
    },
  },
};
</script>
